module.exports = __webpack_public_path__ + "img/005-lawyer.45af00c2.png";